// @section 1 Sunsama-style end-of-day shutdown ritual

import { useState } from 'react';

type Undone = { id: string; title: string };

export function ShutdownModal({
  open,
  onClose,
  undone,
  onFinish,
}: {
  open: boolean;
  onClose: () => void;
  undone: Undone[];
  onFinish: (decisions: Record<string, string>, reflection: string, tomorrowOne: string) => void;
}) {
  const [decisions, setDecisions] = useState<Record<string, string>>({});
  const [reflection, setReflection] = useState('');
  const [tomorrowOne, setTomorrowOne] = useState('');

  if (!open) return null;

  return (
    <div className="cmdk-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="shutdown-modal">
        <div className="shutdown-head">
          <div className="shutdown-eyebrow">End of day</div>
          <div className="shutdown-title">Today's shutdown</div>
        </div>
        <div className="shutdown-body">
          <div>
            <div className="shutdown-label">What didn't get done?</div>
            <ul className="shutdown-list">
              {undone.length === 0 ? <li className="shutdown-empty">Inbox zero — nothing to roll forward.</li> : undone.slice(0, 6).map((t) => (
                <li key={t.id} className="shutdown-row">
                  <span>{t.title}</span>
                  <select
                    value={decisions[t.id] || 'roll-tomorrow'}
                    onChange={(e) => setDecisions({ ...decisions, [t.id]: e.target.value })}
                  >
                    <option value="roll-tomorrow">Roll to tomorrow</option>
                    <option value="roll-week">Roll to next week</option>
                    <option value="drop">Drop</option>
                    <option value="done">Done after all</option>
                  </select>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <div className="shutdown-label">3 lines about today</div>
            <textarea
              value={reflection}
              onChange={(e) => setReflection(e.target.value)}
              placeholder="What worked? What blocked you? What's the lesson?"
              rows={3}
            />
          </div>
          <div>
            <div className="shutdown-label">Tomorrow's #1</div>
            <input
              value={tomorrowOne}
              onChange={(e) => setTomorrowOne(e.target.value)}
              placeholder="Single highest-leverage task for tomorrow"
            />
          </div>
        </div>
        <div className="shutdown-foot">
          <button className="shutdown-cancel" onClick={onClose}>Cancel</button>
          <button className="shutdown-finish" onClick={() => onFinish(decisions, reflection, tomorrowOne)}>
            Roll forward & shut down
          </button>
        </div>
      </div>
    </div>
  );
}
